import { apiStudent } from '@/lib/api-manager'

export const analyzeAcademicTranscript = async (
  requestType: string,
  academicTranscript: File,
  requestId?: string
) => {
  const formData = new FormData()
  formData.append('file', academicTranscript)
  formData.append('requestType', requestType)
  requestId ? formData.append('requestId', requestId) : null

  return (await apiStudent.post('/v1/requests/analyze', formData)).data
}
